import axios from '../../axios-dashboard';

import * as actionTypes from './actionTypes'

export const fetchInstallationStart = () => {
    return {
        type: actionTypes.INSTALLATION_FETCH_START
    }
};

export const fetchInstallationSuccess = (paths) => {
    return {
        type: actionTypes.INSTALLATION_FETCH_SUCCESS,
        tags: paths.tags,
        installations: paths.installations || {}
    }
};

export const fetchInstallationFail = (error) => {
    return {
        type: actionTypes.INSTALLATION_FETCH_FAIL,
        error: error
    }
};

export const editTagStart = () => {
    return {
        type: actionTypes.EDIT_TAG_START
    }
};

export const editTagSuccess = (tags) => {
    return {
        type: actionTypes.EDIT_TAG_SUCCESS,
        tags: tags.tags,
        installations: tags.installations || {}
    }
};

export const editTagFail = (error) => {
    return {
        type: actionTypes.EDIT_TAG_FAIL,
        error: error
    }
};

export const regenCfStart = () => {
    return {
        type: actionTypes.REGEN_CF_START
    }
};

export const regenCfSuccess = (tags) => {
    return {
        type: actionTypes.REGEN_CF_SUCCESS,
        tags: tags.tags,
        installations: tags.installations || {}
    }
};

export const regenCfFail = (error) => {
    return {
        type: actionTypes.REGEN_CF_FAIL,
        error: error
    }
};

export const editTag = (token, tags) => {
    return dispatch => {
        dispatch(editTagStart());
        const url = "/installation";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {tags: tags, action: 'updateTags'})
            .then(response => {
                dispatch(editTagSuccess(response.data))
            })
            .catch(err => {
                dispatch(editTagFail(err.response.data.error))
            })
    }
};

export const regenCf = (token) => {
    return dispatch => {
        dispatch(regenCfStart());
        const url = "/installation";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {action: 'regenCF'})
            .then(response => {
                dispatch(regenCfSuccess(response.data))
            })
            .catch(err => {
                dispatch(regenCfFail(err.response.data.error))
            })
    }
};

export const fetchInstallation = (token) => {
    return dispatch => {
        dispatch(fetchInstallationStart());
        let url = "/installation";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url)
            .then(response => {
                dispatch(fetchInstallationSuccess(response.data))
            })
            .catch(err => {
                dispatch(fetchInstallationFail(err))
            })
    }
};

export const showApiTokenStart = () => {
    return {
        type: actionTypes.SHOW_API_TOKEN_START
    }
};

export const showApiTokenSuccess = (apiToken) => {
    return {
        type: actionTypes.SHOW_API_TOKEN_SUCCESS,
        apiToken: apiToken.apiToken,
    }
};

export const showApiTokenFail = (error) => {
    return {
        type: actionTypes.SHOW_API_TOKEN_FAIL,
        error: error,
    }
};

export const showApiToken = (token) => {
    return dispatch => {
        dispatch(showApiTokenStart());
        let url = "/api-token";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url)
            .then(response => {
                dispatch(showApiTokenSuccess(response.data))
            })
            .catch(err => {
                dispatch(showApiTokenFail(err))
            })
    }
};

export const showTerraformScriptsStart = () => {
    return {
        type: actionTypes.SHOW_TERRAFORM_START
    }
}

export const showTerraformScriptsSuccess = (script) => {
    return {
        type: actionTypes.SHOW_TERRAFORM_SUCCESS,
        terraformScripts: script,
    }
}

export const showTerraformScriptsFail = (error) => {
    return {
        type: actionTypes.SHOW_TERRAFORM_FAIL,
        error: error,
    }
}

export const showTerraformScripts = (token, awsRegions) => {
    return dispatch => {
        dispatch(showTerraformScriptsStart());
        let url = "/installation";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {action: 'showTerraformScripts', regions: awsRegions})
            .then(response => {
                dispatch(showTerraformScriptsSuccess(response.data.terraformScripts))
            })
            .catch(err => {
                dispatch(showTerraformScriptsFail(err))
            })
    }
};